import React from 'react';
import './i18n/i18n';
import ReactDOM from 'react-dom';
import './styles/style.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reduxStore from './state/store';
import { Provider } from "react-redux";

const store = reduxStore;

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
